import React from "react";
import Applications from "./fc-applications";
import Carousel from "./fc-carousel";
import ContentHighlight from "./fc-content-highlight";
import ContentList from "./fc-content-list";
import CopyBlock from "./fc-copy-block";
import CopyBlockPage from "./fc-copy-block-page";
import Images from "./fc-images";
import MediaCopyBlocks from "./fc-media-copy-blocks";
import MultiCards from "./fc-multi-cards";
import Partners from "./fc-partners";
import Products from "./fc-products";
import Projects from "./fc-projects";
import Stats from "./fc-stats";
import TwoUpMedia from "./fc-two-up-media";
import Updates from "./fc-updates";
import Video from "./fc-video";
import VideoPage from "./fc-video-page";

interface FlexibleContentItem {
  _key: string;
  _type: string;
  // Add other common fields here as needed
  [key: string]: any; // Allow for additional properties based on the flexible content type
}

interface FlexibleContentProps {
  items?: FlexibleContentItem[];
}

const FlexibleContent: React.FC<FlexibleContentProps> = ({ items, theme }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <>
      {items.map((node) => {
        switch (node._type) {
          case `fcApplications`:
            return <Applications key={node._key} {...node} />;
          case `fcCarousel`:
            return <Carousel key={node._key} {...node} />;
          case `fcContentHighlight`:
            return <ContentHighlight key={node._key} {...node} />;
          case `fcContentList`:
            return <ContentList key={node._key} {...node} theme={theme} />;
          case `fcCopyBlock`:
            return <CopyBlock key={node._key} {...node} />;
          case `fcCopyBlockPage`:
            return <CopyBlockPage key={node._key} {...node} />;
          case `fcImages`:
            return <Images key={node._key} {...node} />;
          case `fcMediaCopyBlocks`:
            return <MediaCopyBlocks key={node._key} {...node} />;
          case `fcMultiCards`:
            return <MultiCards key={node._key} {...node} />;
          case `fcPartners`:
            return <Partners key={node._key} {...node} />;
          case `fcProducts`:
            return <Products key={node._key} {...node} />;
          case `fcProjects`:
            return <Projects key={node._key} {...node} theme={theme} />;
          case `fcStats`:
            return <Stats key={node._key} {...node} />;
          case `fcTwoUpMedia`:
            return <TwoUpMedia key={node._key} {...node} />;
          case `fcUpdates`:
            return <Updates key={node._key} {...node} theme={theme} />;
          case `fcVideo`:
            return <Video key={node._key} {...node} />;
          case `fcVideoPage`:
            return <VideoPage key={node._key} {...node} />;
          default:
            return null;
        }
      })}
    </>
  )
};

export default FlexibleContent;
